<template>
  <p class="warn-content" style="text-align: center">
    <span v-show="$route.meta.title!=='建设中...'">{{ $route.meta.title }}</span>建设中...
  </p>
</template>

<script>
export default {
  name: 'SaleDaily'
}
</script>

<style scoped>
  .warn-content {
    margin: 0;
    background-color: #fff;
  }
</style>
